module.exports = __webpack_public_path__ + "static/media/news-schwartz.f1723e18.jpg";